<script setup>
import channelsightWidget from './js/channelsight-widget.js';
import dataModel from './js/model.js';
import hero from './components/hero.vue';
import widget from './components/widget.vue';
import carousel from './components/carousel.vue';
import recipes1 from './components/recipes1.vue';
import recipes2 from './components/recipes2.vue';
import terms from './components/terms.vue';

//invoke the channelsight widget
channelsightWidget();

//grab URL parameter to determine experience
let params = new URLSearchParams(document.location.search);
let brandContextParam = params.get("brandContext");

//parse URL parameter ready to pass to component
var brandContext = !brandContextParam == '' ? brandContext=brandContextParam : console.log('Generating experience ' + brandContextParam);

</script>

<template>
  <hero :brandExperience="brandContext" />
  <widget :brandExperience="brandContext" />
  <carousel :iteration="'1'"/>
  <recipes1 :brandExperience="brandContext" />
  <recipes2 :brandExperience="brandContext" />
  <terms :brandExperience="brandContext" />
  
</template>

<style>
body {
  margin: 0;
  
}
#app {
  text-align: center;
  background: url('/public/misc/tile.jpg');
  background-size: 400px;
  background-repeat: repeat;
  overflow: hidden;
}
</style>
